module.exports = "<div class=\"animated fadeIn\">\r\n  <form-status [status]=\"status\"></form-status>\r\n  <form-consulter [referenceNum]=\"referenceNum\" (statuschange)=\"status=$event\"  (loading)=\"loading=$event\"></form-consulter>\r\n</div>\r\n\r\n<ngx-loading [show]=\"loading\" [config]=\"{ fullScreenBackdrop:true }\"></ngx-loading>"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/display/display.component.html
// module id = ../../../../../src/app/views/display/display.component.html
// module chunks = main